/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import RefinementCondition, { recent } from 'cio/app-models/conditions/refinement';

interface CioConditionViewerRefinementArgs {
  refinement: RefinementCondition;
  tagName?: string;
}

export default class CioConditionViewerRefinement extends Component<CioConditionViewerRefinementArgs> {
  get tagName() {
    return this.args.tagName ?? 'span';
  }

  get hasTimeRange() {
    return this.args.refinement.period === recent;
  }
}
